import type { Answers, Question } from '../types';

export function ProgressWrap({ questions, answers, current }: { questions: Question[]; answers: Answers; current: number }) {
  const total = questions.length;
  const answered = questions.filter(q => answers.has(q.id)).length;
  const ok = questions.filter(q => answers.get(q.id)?.ok).length;
  const no = answered - ok;
  const pct = total ? Math.round((answered / total) * 100) : 0;

  return (
    <div className="progress-wrap">
      <div className="progress-top">
        <span>{total ? `第 ${Math.min(current + 1, total)} / ${total} 题` : '无题目'}</span>
        <span>{pct}%</span>
      </div>
      <div className="progress-track"><div className="progress-fill" style={{ width: pct + '%' }} /></div>
      <div className="score-grid">
        <span className="ok">正确 <b>{ok}</b></span>
        <span className="no">错误 <b>{no}</b></span>
        <span className="rate">正确率 <b>{answered ? Math.round((ok / answered) * 100) + '%' : '-'}</b></span>
      </div>
    </div>
  );
}
